<div class="bg-white rounded-lg">
  <div class="border-b border-gray-200">
    <nav class="flex space-x-8 px-6" aria-label="Tabs">
      <button 
        *ngFor="let tab of tabs"
        (click)="onTabClick(tab.id)"
        [class]="activeTab === tab.id 
          ? 'border-red-500 text-red-600 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm' 
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'">
        <mat-icon class="mr-2 align-text-bottom">{{ tab.icon }}</mat-icon>
        {{ tab.translationKey | translate }}
      </button>
    </nav>
  </div>
  <div class="p-6">
    <ng-content></ng-content>
  </div>
</div>
